import React, { forwardRef } from 'react';
import { GroupContainer } from './Group.styled';
import {} from './Group.types';
export const Group = forwardRef((props, ref) => (React.createElement(GroupContainer, { ref: ref, role: "group" }, props.children)));
